/**
 * Fusion — Enquiry list
 *
 * A cart-like, no-checkout "request list": a shopper adds products while
 * browsing, then submits the whole list as one enquiry via Shopify's native
 * contact form (snippets/enquiry-list section) — no app, no payment, no real
 * Shopify cart involved. Storage is a plain localStorage array, entirely
 * separate from routes.cart_url and the (hidden, in coming-soon mode) real
 * cart, so this never touches actual cart/checkout state.
 */

(function () {
  var STORAGE_KEY = 'fusion:enquiry-list';
  var EVENT_NAME = 'fusion:enquiry-list-change';

  function readList() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (error) {
      return [];
    }
  }

  function writeList(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (error) {
      /* Storage unavailable (private mode, quota) — fail silently, the list
         just won't persist across page loads for this visitor. */
    }
    var count = list.reduce(function (total, item) { return total + item.quantity; }, 0);
    document.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: { list: list, count: count } }));
  }

  function addItem(item) {
    var list = readList();
    var existing = list.find(function (row) { return row.variantId === item.variantId; });
    if (existing) {
      existing.quantity += item.quantity;
    } else {
      list.push(item);
    }
    writeList(list);
  }

  function updateQuantity(variantId, quantity) {
    var list = readList();
    if (quantity <= 0) {
      list = list.filter(function (row) { return row.variantId !== variantId; });
    } else {
      var row = list.find(function (r) { return r.variantId === variantId; });
      if (row) row.quantity = quantity;
    }
    writeList(list);
  }

  function removeItem(variantId) {
    updateQuantity(variantId, 0);
  }

  function clearList() {
    writeList([]);
  }

  window.FusionEnquiryList = {
    read: readList,
    add: addItem,
    updateQuantity: updateQuantity,
    remove: removeItem,
    clear: clearList,
  };

  /* -- Header/PDP count badge --------------------------------------------- */

  class FusionEnquiryCount extends HTMLElement {
    connectedCallback() {
      this.render(readList());
      document.addEventListener(EVENT_NAME, (event) => this.render(event.detail.list));
    }

    render(list) {
      var count = list.reduce(function (total, item) { return total + item.quantity; }, 0);
      this.textContent = count;
      this.classList.toggle('is-empty', count === 0);
      var wrapper = this.closest('[data-enquiry-list-link]');
      if (wrapper) wrapper.classList.toggle('is-empty', count === 0);
    }
  }

  if (!customElements.get('fusion-enquiry-count')) {
    customElements.define('fusion-enquiry-count', FusionEnquiryCount);
  }

  /* -- PDP "Add to list" button -------------------------------------------- */

  class FusionAddToList extends HTMLElement {
    connectedCallback() {
      var button = this.querySelector('[data-add-to-list-submit]');
      var continueLink = this.querySelector('[data-add-to-list-continue]');
      if (!button) return;

      button.addEventListener('click', () => {
        var quantityInput = this.querySelector('[data-add-to-list-quantity]');
        var quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

        addItem({
          variantId: this.dataset.variantId,
          productId: this.dataset.productId,
          title: this.dataset.title,
          variantTitle: this.dataset.variantTitle,
          image: this.dataset.image,
          url: this.dataset.url,
          quantity: quantity,
        });

        // Same check-icon swap pattern as the (hidden) real add-to-cart
        // button, so this reads as a familiar, immediate confirmation.
        var text = button.querySelector('[data-add-to-list-text]');
        var check = button.querySelector('.button__check');
        if (text) text.classList.add('hidden');
        if (check) check.classList.remove('hidden');
        button.disabled = true;

        if (continueLink) continueLink.classList.remove('hidden');

        window.setTimeout(() => {
          if (text) text.classList.remove('hidden');
          if (check) check.classList.add('hidden');
          button.disabled = false;
        }, 1800);
      });
    }
  }

  if (!customElements.get('fusion-add-to-list')) {
    customElements.define('fusion-add-to-list', FusionAddToList);
  }
})();
